import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ManagerTeacher } from '@isophi/mng-api';

@Component({
  selector: 'app-pap-autoevaluation-row',
  templateUrl: './pap-autoevaluation-row.component.html',
  styleUrls: ['./pap-autoevaluation-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PapAutoevaluationRowComponent {
  @Input() teacher: ManagerTeacher;

  get isCompleted(): boolean {
    if (!this.teacher.lastEvaluationDate) {
      return false;
    }

    const today = new Date();
    const nextEvaluationWarningDate = new Date(this.teacher.lastEvaluationDate);
    nextEvaluationWarningDate.setMonth(nextEvaluationWarningDate.getMonth() + 11);

    return today <= nextEvaluationWarningDate;
  }

  get nextEvaluationDate(): Date {
    if (!this.teacher.lastEvaluationDate) {
      return null;
    }

    const nextEvaluationDate = new Date(this.teacher.lastEvaluationDate);
    nextEvaluationDate.setFullYear(nextEvaluationDate.getFullYear() + 1);

    return nextEvaluationDate;
  }
}
